import { User } from 'contracts/Users';
import { api } from 'services';

export async function unlockLogin(userId: number | string): Promise<User> {
  const { data } = await api.patch(`/users/${userId}/unlock-login`);
  return data;
}
